import React, { useState } from 'react';
import { PropTypes } from 'prop-types';

import {
  Input, Select, Form, Row, Col, Checkbox,
} from 'antd';
import { useSelector } from 'react-redux';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import {
  Currencies,
  PaymentMethods,
  ServiceTypes,
  TrafficTypes,
} from '../../constants/System';

const { Option } = Select;
const formItemLayout = {
  labelCol: {
    span: 12,
  },
  wrapperCol: {
    span: 12,
  },
};

const ProcessorForm = ({
  form,
  handleChangeTrafficType,
  selectedTrafficTypes,
  handleChangeServiceType,
  selectedServiceType,
  handleChangeCurrency,
  selectedCurrency,
  handleChangePaymentMethod,
  selectedPaymentMethod,
  minimumAmount,
  maximumAmount,
  handleChange,
  newRecord,
}) => {
  const { authUser } = useSelector(({ auth }) => auth);
  const [midOperator, setMidOperator] = useState(false);
  const [midUsername, setMidUsername] = useState(false);
  const [midPassword, setMidPassword] = useState(false);

  const trafficTypeOptions = TrafficTypes
    && TrafficTypes.map((trafficType) => (
      <Option className="gx-text-capitalize" key={trafficType}>
        {trafficType}
      </Option>
    ));

  const serviceTypeOptions = ServiceTypes
    && ServiceTypes.map((serviceType) => (
      <Option className="gx-text-capitalize" key={serviceType}>
        {serviceType}
      </Option>
    ));

  const currencyOptions = Currencies
    && Currencies.map((currency) => (
      <Option className="gx-text-capitalize" key={currency}>
        {currency}
      </Option>
    ));

  const paymentMethodOptions = PaymentMethods
    && PaymentMethods.map((paymentMethod) => (
      <Option className="gx-text-capitalize" key={paymentMethod}>
        {paymentMethod}
      </Option>
    ));

  return (
    <Form name="basic" className="gx-form-row0" ref={form} {...formItemLayout}>
      <Row>
        <Col xl={15} lg={15} md={12} sm={24} xs={12}>
          <Form.Item
            rules={[{ required: true, message: 'This input is required!' }]}
            name="name"
            label="Mid Business Name"
          >
            <Input placeholder="Mid Business Name" />
          </Form.Item>
          <Form.Item rules={[{ required: false }]} label="Service Type">
            <Select
              allowClear
              style={{ width: '100%' }}
              placeholder="Select service type"
              value={selectedServiceType}
              onChange={handleChangeServiceType}
              showSearch
              optionFilterProp="children"
              filterOption={
                (input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {serviceTypeOptions}
            </Select>
          </Form.Item>
          <Form.Item rules={[{ required: false }]} label="Payment Method">
            <Select
              allowClear
              style={{ width: '100%' }}
              placeholder="Select payment Method"
              value={selectedPaymentMethod}
              onChange={handleChangePaymentMethod}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            >
              {paymentMethodOptions}
            </Select>
          </Form.Item>
          <Form.Item rules={[{ required: false }]} label="Currency">
            <Select
              allowClear
              style={{ width: '100%' }}
              placeholder="Select currency"
              value={selectedCurrency}
              onChange={handleChangeCurrency}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            >
              {currencyOptions}
            </Select>
          </Form.Item>
          <Form.Item rules={[{ required: false }]} label="Allowed traffic">
            <Select
              mode="multiple"
              allowClear
              style={{ width: '100%' }}
              placeholder="Select allowed traffic type"
              value={selectedTrafficTypes}
              onChange={handleChangeTrafficType}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            >
              {trafficTypeOptions}
            </Select>
          </Form.Item>
          {(authUser.role.name === 'AFFILIATE'
            || authUser.role.name === 'BUSINESS') && (
            <Form.Item
              label="Enable Affiliate"
              name="enable_affiliate"
              valuePropName="checked"
            >
              <Checkbox />
            </Form.Item>
          )}
          {newRecord && (
            <>
              <Form.Item name="mid_operator" label="Merchant Operator">
                <Input.Password
                  iconRender={(visible) => (visible ? (
                    <EyeTwoTone onClick={() => setMidOperator(false)} />
                  ) : (
                    <EyeInvisibleOutlined
                      onClick={() => setMidOperator(true)}
                    />
                  ))}
                  type={midOperator ? 'text' : 'password'}
                />
              </Form.Item>
              <Form.Item
                rules={[{ required: true, message: 'This input is required!' }]}
                name="mid_username"
                label="Merchant Username"
              >
                <Input.Password
                  iconRender={(visible) => (visible ? (
                    <EyeTwoTone onClick={() => setMidUsername(false)} />
                  ) : (
                    <EyeInvisibleOutlined
                      onClick={() => setMidUsername(true)}
                    />
                  ))}
                  type={midUsername ? 'text' : 'password'}
                />
              </Form.Item>
              <Form.Item
                rules={[{ required: true, message: 'This input is required!' }]}
                name="mid_password"
                label="Merchant Password"
              >
                <Input.Password
                  iconRender={(visible) => (visible ? (
                    <EyeTwoTone onClick={() => setMidPassword(false)} />
                  ) : (
                    <EyeInvisibleOutlined
                      onClick={() => setMidPassword(true)}
                    />
                  ))}
                  type={midPassword ? 'text' : 'password'}
                />
              </Form.Item>
            </>
          )}
          {(!authUser.role.name.includes('Merchant')) && (
            <>
              <Form.Item label="Is Production Mid" name="mid_is_production" valuePropName="checked">
                <Checkbox />
              </Form.Item>
              <Form.Item label="Mid URL" name="mid_url">
                <Input placeholder="Mid URL" />
              </Form.Item>
            </>
          )}
          <Form.Item label="Processing Rank" name="rank" initialValue={1}>
            <Input placeholder="Rank" />
          </Form.Item>
          <Form.Item label="Reject First Time Depositors" name="deny_ftds" valuePropName="checked">
            <Checkbox />
          </Form.Item>
          <Form.Item label="Active" name="is_active" valuePropName="checked">
            <Checkbox />
          </Form.Item>
        </Col>
        <Col xl={9} lg={9} md={12} sm={24} xs={12}>
          <Form.Item
            rules={[
              { required: true, message: 'This input is required!' },
            ]}
            label="Acquirer/PSP Charge (Fixed)"
            name="processor_fixed_charge"
          >
            <Input placeholder="Acquirer/PSP Charge (Fixed)" />
          </Form.Item>
          <Form.Item
            rules={[
              { required: true, message: 'This input is required!' },
            ]}
            label="Acquirer/PSP Charge (%)"
            name="processor_percentage_charge"
          >
            <Input placeholder="Acquirer/PSP Charge (%)" />
          </Form.Item>
          <Form.Item
            rules={[
              { required: true, message: 'This input is required!' },
            ]}
            label="Our Charge (fixed)"
            name="p2p_fixed_charge"
          >
            <Input placeholder="Our Charge (fixed)" />
          </Form.Item>

          <Form.Item
            rules={[
              { required: true, message: 'This input is required!' },
            ]}
            label="Our Charge (%)"
            name="p2p_percentage_charge"
          >
            <Input placeholder="Our Charge (%)" />
          </Form.Item>
          <Form.Item
            label="Refund Fixed Charge"
            name="refund_charge"
            initialValue={0}
          >
            <Input placeholder="Refund Fixed Charge" />
          </Form.Item>
          <Form.Item
            label="Chargeback Fixed Charge"
            name="chargeback_charge"
            initialValue={0}
          >
            <Input placeholder="Chargeback Fixed Charge" />
          </Form.Item>
          <Form.Item
            label="Settlement Fixed Charge"
            name="settlement_charge"
            initialValue={0}
          >
            <Input placeholder="Settlement Fixed Charge" />
          </Form.Item>
          <Form.Item
            label="Currency Decimal Places"
            name="decimal_places"
            initialValue={0}
          >
            <Input placeholder="Currency Decimal Places" />
          </Form.Item>
          <Form.Item label="Minimum Amount">
            <Select
              name="minimum_amount"
              value={minimumAmount}
              onChange={(e) => handleChange(e, 'minimum_amount')}
            >
              <Option key={0}>0</Option>
              <Option key={1}>1</Option>
              <Option key={5}>5</Option>
              <Option key={10}>10</Option>
              <Option key={20}>20</Option>
              <Option key={50}>50</Option>
              <Option key={100}>100</Option>
              <Option key={200}>200</Option>
              <Option key={300}>300</Option>
              <Option key={400}>400</Option>
              <Option key={500}>500</Option>
              <Option key={1000}>1000</Option>
            </Select>
          </Form.Item>
          <Form.Item label="Maximum Amount">
            <Select
              name="maximum_amount"
              value={maximumAmount}
              onChange={(e) => handleChange(e, 'maximum_amount')}
            >
              <Option key={0}>0</Option>
              <Option key={50}>50</Option>
              <Option key={100}>100</Option>
              <Option key={500}>500</Option>
              <Option key={1000}>1000</Option>
              <Option key={2000}>2000</Option>
              <Option key={3000}>3000</Option>
            </Select>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

ProcessorForm.propTypes = {
  form: PropTypes.shape({
    current: PropTypes.shape({}),
  }),
  handleChangeTrafficType: PropTypes.func.isRequired,
  selectedTrafficTypes: PropTypes.string.isRequired,
  handleChangeServiceType: PropTypes.func.isRequired,
  selectedCurrency: PropTypes.string.isRequired,
  handleChangeCurrency: PropTypes.func.isRequired,
  selectedPaymentMethod: PropTypes.string.isRequired,
  handleChangePaymentMethod: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  selectedServiceType: PropTypes.string.isRequired,
  minimumAmount: PropTypes.number,
  maximumAmount: PropTypes.number,
  newRecord: PropTypes.bool,
};

ProcessorForm.defaultProps = {
  form: {},
  minimumAmount: 0,
  maximumAmount: 0,
  newRecord: false,
};

export default ProcessorForm;
